import { Action } from 'redux';

import {
    ClConfirmedShareClientScreenAction,
    ClSessionCreatedAction,
    ClSharingAction,
    ClShowSharingRequestAction,
    SharingActionType,
    StartSharingViewerAction,
} from './sharing.actions';

export interface SharingState {
    event: SharingActionType;
    userId: string;
    roomId: string;
    clUserId: number;
    clRoomId: string;
    clTurnData: TurnServerData;
    show: boolean;
    clSharing: boolean;
    clShowSharingRequest: boolean;
    clConfirmedShareClientScreen: boolean;
}
export interface TurnServerData {
    password: string;
    urls: string[];
    user: string;
}

export const defaultTurnServerData: TurnServerData = {
    password: '',
    urls: [],
    user: '',
};

const initialState: SharingState = {
    event: SharingActionType.DEFAULT,
    userId: null as string,
    roomId: null as string,
    clUserId: -1,
    clRoomId: null as string,
    clTurnData: defaultTurnServerData,
    show: false,
    clSharing: false,
    clShowSharingRequest: false,
    clConfirmedShareClientScreen: false,
};
export const defaultSharingState = initialState;

export const sharingReducer = (state = initialState, action: Action<SharingActionType>) => {
    switch (action.type) {
        case SharingActionType.StartViewer:
            const { userId, roomId } = (action as StartSharingViewerAction).payload;
            return {
                ...state,
                event: SharingActionType.StartViewer,
                userId,
                roomId,
            };

        case SharingActionType.StopViewer:
            return { ...initialState, event: SharingActionType.StopViewer };

        case SharingActionType.ShowViewer:
            return {
                ...state,
                event: SharingActionType.ShowViewer,
                show: true,
            };

        case SharingActionType.HideViewer:
            return {
                ...state,
                event: SharingActionType.HideViewer,
                show: false,
            };

        case SharingActionType.CL_CONFIRMED_SHARE_CLIENT_SCREEN:
            return {
                ...state,
                event: SharingActionType.CL_CONFIRMED_SHARE_CLIENT_SCREEN,
                clConfirmedShareClientScreen: (action as ClConfirmedShareClientScreenAction).payload
                    .clConfirmedShareClientScreen,
            };

        case SharingActionType.CL_REQUEST_MEDIA:
        case SharingActionType.CL_CREATE_SESSION:
            return {
                ...state,
                event: action.type,
            };

        case SharingActionType.CL_CREATE_SESSION_TIMEOUT:
        case SharingActionType.CL_REJECT_MEDIA:
            return {
                ...defaultSharingState,
                event: action.type,
            };

        case SharingActionType.CL_SESSION_CREATED:
            const { clUserId, clRoomId, clTurnData } = (action as ClSessionCreatedAction).payload;
            return {
                ...state,
                event: action.type,
                clUserId,
                clRoomId,
                clTurnData,
            };

        case SharingActionType.CL_SHARING:
            const { clSharing } = (action as ClSharingAction).payload;
            return {
                ...state,
                event: action.type,
                clSharing,
            };

        case SharingActionType.CL_SHOW_SHARING_REQUEST:
            const { clShowSharingRequest } = (action as ClShowSharingRequestAction).payload;
            return {
                ...state,
                event: action.type,
                clShowSharingRequest,
            };

        case SharingActionType.CL_INACTIVATE:
            return {
                ...state,
                event: SharingActionType.CL_INACTIVATE,
            };

        case SharingActionType.CL_OPERATOR_REQUESTS_SHARING:
            return {
                ...state,
                event: SharingActionType.CL_OPERATOR_REQUESTS_SHARING,
            };

        default:
            return state;
    }
};
